import { deviceSizes } from "./constants";

/** width < tablet (768) — matches theme.sizes.isMobile */
export const mobileOnly = `@media (max-width: ${deviceSizes.tablet - 1}px)`;

/** width >= tablet (768) — matches !theme.sizes.isMobile */
export const tabletUp = `@media (min-width: ${deviceSizes.tablet}px)`;

/** tablet only: 768–991 — Semantic tablet band */
export const tabletOnly = `@media (min-width: ${deviceSizes.tablet}px) and (max-width: ${deviceSizes.laptop - 1}px)`;

/** width >= laptop / computer (992) — matches theme.sizes.isComputer */
export const computerUp = `@media (min-width: ${deviceSizes.laptop}px)`;

/** width < laptop / computer (992) — matches !theme.sizes.isComputer */
export const belowComputer = `@media (max-width: ${deviceSizes.laptop - 1}px)`;

/** computer only: 992–1199 — Semantic small-monitor band */
export const computerOnly = `@media (min-width: ${deviceSizes.laptop}px) and (max-width: ${deviceSizes.laptopL - 1}px)`;

/** width >= laptopL / large (1200) — matches theme.sizes.isLargeComputer */
export const largeComputerUp = `@media (min-width: ${deviceSizes.laptopL}px)`;
